export default __webpack_public_path__ + "assets/img_calculator_boat_cheap-9e2dbed7.jpg";